import DateFnsUtils from '@date-io/date-fns'
import {
  DateTimePicker as Mui4DateTimePicker,
  DateTimePickerProps as Mui4DateTimePickerPropsType,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers'
import { DateTimePicker as Mui5DateTimePicker } from '@mui/x-date-pickers'
import { forwardRef } from 'react'
import { useComponentVersion } from '../hooks'
import { DATE_TIME_PICKER_PROPS, withPickerDayjs } from '../utils/pickerDateValues'
import { Button } from './Button'

export enum OsDateTimePickerVersion {
  V1 = 1, // MUI4 + OS Theme
  V2 = 2, // MUI5 + Stratis
}

export type DateTimePickerProps = Mui4DateTimePickerPropsType

// * MUI DateTimePicker API Spec  https://mui.com/x/react-date-pickers/date-time-picker/
export const DateTimePicker = forwardRef<HTMLDivElement, DateTimePickerProps>((props, ref) => {
  const version = useComponentVersion('date_picker')

  switch (version) {
    case OsDateTimePickerVersion.V2: {
      return (
        //@ts-ignore
        <Mui5DateTimePicker
          ref={ref}
          slotProps={{
            dialog: {
              sx: {
                zIndex: 2000,
              },
            },
            popper: {
              sx: {
                zIndex: 2000,
              },
            },
            textField: {
              InputProps: {
                color: 'secondary',
              },
            },
          }}
          slots={{
            actionBar: (props) => (
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button onClick={props.onAccept} color="secondary" variant="text">
                  OK
                </Button>
              </div>
            ),
          }}
          {...withPickerDayjs(props, ...DATE_TIME_PICKER_PROPS)}
        />
      )
    }

    default:
      return (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <Mui4DateTimePicker ref={ref} {...props} />
        </MuiPickersUtilsProvider>
      )
  }
})
